export const personAssignmentHistoryColumnWidths = {
  taskId: '7%',
  taskName: '11%',
  type: '10%',
  taskType: '10%',
  asset: '10%',
  date: '8%',
  user: '9%',
  employees: '9%',
  department: '9%',
  isValidation: '5%',
  errors: '12%'
} as const;
